import { ltGtMediaQuery, ltSmMediaQuery } from 'root/src/client/web/commonStyles'

export default {
	root: {
		padding: [[100, 0, 70, 0]],
		maxWidth: 1680,
		margin: [[0, 'auto']],
		width: '100%',
		[ltGtMediaQuery]: {
			padding: [[25, 0, 20]],
		},
	},
	maxWidth: {
		maxWidth: 1680,
		width: '100%',
		margin: [[0, 'auto']],
		padding: [[100, 0, 70, 0]],
	},
	sliderItems: {
		justifyContent: 'center',
	},
	slideContainer: {
		display: 'flex',
		alignItems: 'center',
		width: '33%',
		justifyContent: 'center',
		[ltGtMediaQuery]: {
			width: '100vw',
		},
	},
	itemContainer: {
		width: '20vw',
		height: 'auto',
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		[ltGtMediaQuery]: {
			display: 'block',
			width: '44%',
		},
	},
	image: {
		width: '100%',
		userDrag: 'none',
		userSelect: 'none',
		'-moz-user-select': 'none',
		'-webkit-user-drag': 'none',
		'-webkit-user-select': 'none',
		'-ms-user-select': 'none',
		cursor: 'pointer',
	},
	arrowRectContainer: {
		position: 'relative',
		width: '28%',
	},
	arrowRect: {
		position: 'absolute',
		top: '50%',
		left: '100%',
		transform: 'translate(-50%, -50%)',
		width: '100%',
		maxWidth: 125,
		height: 8,
		margin: 0,
		borderRadius: 4,
		[ltGtMediaQuery]: {
			maxWidth: 'none',
		},
	},
	item: {
		height: 'auto',
		margin: '0',
	},
	textItemContainer: {
		width: '20%',
		display: 'flex',
	},
	textItem: {
		width: '125%',
	},
	itemHeadingContainer: {
		marginTop: 20,
		marginBottom: 10,
		textTransform: 'upperCase',
		textAlign: 'center',
		[ltGtMediaQuery]: {
			marginTop: 10,
			marginBottom: 10,
		},
	},
	itemSubHeadingContainer: {
		textAlign: 'center',
		paddingTop: 10,
	},
	itemSubHeading: {
		fontSize: 16,
		'@media (max-width: 1377px)': {
			fontSize: 14,
		},
		'@media (max-width: 1225px)': {
			fontSize: 12,
		},
		'@media (max-width: 1075px)': {
			fontSize: 11,
		},
		[ltGtMediaQuery]: {
			fontSize: 15,
		},
		[ltSmMediaQuery]: {
			fontSize: 14,
		},
		color: 'white',
	},
	btnContainer: {
		margin: '0 auto',
		marginTop: 50,
		height: 50,
		width: 250,
		'@media(max-width: 700px)': {
			marginTop: 0,
		},
	},
	buttonsContainer: {
		width: '30%',
		display: 'flex',
		margin: [[0, 'auto']],
		'@media(max-width: 1400px)': {
			width: '40%',
		},
		[ltGtMediaQuery]: {
			width: '70%',
		},
		'@media(max-width: 580px)': {
			width: '90%',
		},
		'@media(max-width: 400px)': {
			width: '100%',
		},
	},
}
